import { GET_USERS_REPORT, GET_PHRASES_REPORT, GET_WEBSITES_REPORT, GET_SUPERVISOR_REPORT, GET_SUPERVISOR_LOGIN_REPORT } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
import moment from 'moment'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getUsersReport = (Filter, order) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = { filter: { units: Filter.units, order, supervisorID } }
    if (!body.filter.units || !body.filter.units.length) { body.filter.units = getState().auth.assignedUnits }
    if (!body.filter.units || !body.filter.units.length) { return false }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/reports/users`, options))

    if (!response.status || response.status === 401 || response.status === 500) {
      log.warn('non 200 status code from problem report')
    } else {
      const { data } = await response.json()

      dispatch({
        type: GET_USERS_REPORT,
        payload: data.aggregations.all_users.buckets
      })
    }
  }
}

export const getPhrasesReport = (Filter) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = { filter: { units: Filter.units, supervisorID } }
    if (!body.filter.units || !body.filter.units.length) { body.filter.units = getState().auth.assignedUnits }
    if (!body.filter.units || !body.filter.units.length) { return false }
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/reports/phrases`, options))

    if (!response.status || response.status === 401 || response.status === 500) {
      log.warn('non 200 status code from phrases report')
    } else {
      const { data } = await response.json()

      dispatch({
        type: GET_PHRASES_REPORT,
        payload: data.aggregations.problem_phrases.buckets
      })
    }
  }
}

export const getWebsitesReport = (Filter) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = { filter: { units: Filter.units, supervisorID } }
    if (!body.filter.units || !body.filter.units.length) { body.filter.units = getState().auth.assignedUnits }
    if (!body.filter.units || !body.filter.units.length) { return false }
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/reports/websites`, options))

    if (!response.status || response.status === 401 || response.status === 500) {
      log.warn('non 200 status code from websites report')
    } else {
      const { data } = await response.json()

      dispatch({
        type: GET_WEBSITES_REPORT,
        payload: data.aggregations.problem_websites.buckets
      })
    }
  }
}

/**
 * Gets a list of supervisors with actions taken during a timeframe
 * @param {Object} Filter mapped filter from redux state
 * @param {Number} Filter.startDate unix timestamp to begin the query. Defaults to 0
 * @param {Number} Filter.endDate unix timestamp to end the query. Defaults to 0
 * @returns Array of supervisors with relevant stats for the given timeframe
 */
export const getSupervisorReport = (Filter) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { ...Filter }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/actions`, options))

    if (!response.status || response.status === 401 || response.status === 500) {
      log.warn('non 200 status code from supervisor report')
    } else {
      const { data } = await response.json()

      dispatch({
        type: GET_SUPERVISOR_REPORT,
        payload: data
      })
    }
  }
}

/**
 * Gets a list of users on whose captures a supervisor performed a certain action within the given timeframe
 * @param {Object} Filter container object with opts
 * @param {String} Filter.supervisorID ID of the supervisor that performed the action
 * @param {String} Filter.actionType action taken on the capture. Maps to a string value set associated the actions table
 * @param {Number} Filter.startDate unix timestamp to begin the query. Defaults to 0
 * @param {Number} Filter.endDate unix timestamp to end the query. Defaults to 0
 * @returns Array of users that match the filter/action criteria
 */
export const getSupervisorUserReport = (Filter) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { ...Filter }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/actions/users`, options))

    if (!response.status || response.status === 401 || response.status === 500) {
      log.warn('non 200 status code from supervisor report')
      return false
    } else {
      const { data } = await response.json()
      return data
    }
  }
}

/**
 * Gets a list of users on whose captures a supervisor performed a certain action within the given timeframe
 * @param {Object} Filter container object with opts
 * @param {Number} Filter.startDate unix timestamp to begin the query. Defaults to 0
 * @param {Number} Filter.endDate unix timestamp to end the query. Defaults to 0
 * @returns Array of users that match the filter/action criteria
 */
export const getSupervisorLoginReport = (Filter) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { ...Filter }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/logins`, options))

    if (!response.status || response.status === 401 || response.status === 500) {
      log.warn('non 200 status code from supervisor report')
    } else {
      const { data } = await response.json()

      dispatch({
        type: GET_SUPERVISOR_LOGIN_REPORT,
        payload: data
      })
    }
  }
}

/**
 * Gets a list of users on whose captures a supervisor performed a certain action within the given timeframe
 * @param {Object} Filter container object with opts
 * @param {Number} Filter.startDate unix timestamp to begin the query. Defaults to 0
 * @param {Number} Filter.endDate unix timestamp to end the query. Defaults to 0
 * @param {String} supervisorID ID of the supervisor that performed the action
 * @returns Array of users that match the filter/action criteria
 */
export const getSupervisorSingleLoginReport = (Filter, supervisorID) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { ...Filter }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/logins`, options))

    if (!response.status || response.status === 401 || response.status === 500) {
      log.warn('non 200 status code from supervisor report')
      return false
    } else {
      const { data } = await response.json()

      // Remove current login sessions based on endedAt timestamp being greater than the current one
      if (data) {
        data.forEach((loginInfo, index) => {
          if (loginInfo.endedAt > moment().unix()) { data.splice(index, 1) }
        })
      }

      return data
    }
  }
}
